/**
 * Labstep
 *
 * @module components/FilterPost/Report/Date/Form
 * @desc Filter Metadata form
 */

import { FormReusableGroup } from 'labstep-web/core/Form/Reusable/Group';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import { PostFilterDate } from 'labstep-web/services/postFilter/date';
import type React from 'react';
import { useCallback, useState } from 'react';
import {
  COMPARISON_OPTIONS,
  fieldComparison,
  fieldDate,
} from './fields';
import type { IFilterPostReportDateFormProps } from './types';

export const getPostFilterDate = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  if (comparison === PostFilterComparison.not_null) {
    return new PostFilterDate([[field, comparison]], path);
  }

  return new PostFilterDate([[field, comparison]], path);
};

export const FilterPostReportDateForm: React.FC<
  IFilterPostReportDateFormProps
> = ({
  addPostFilter,
  onDone,
  path,
  field,
  defaultValues,
  replace,
}) => {
  const [fields, setFields] = useState([fieldComparison]);

  const onSubmit = useCallback(
    (values): void => {
      const { comparison } = values;
      let { value } = values;
      if (comparison.value === PostFilterComparison.not_null) {
        value = undefined;
      }
      addPostFilter(
        getPostFilterDate(field, comparison.value, path).getNode([
          value,
        ]),
        true,
      );
      onDone();
    },
    [path, addPostFilter],
  );

  return (
    <FormReusableGroup
      fields={fields}
      onSubmit={onSubmit}
      onDone={onDone}
      defaultValues={{
        comparison: COMPARISON_OPTIONS[2],
        ...defaultValues,
      }}
      onFormChange={({ comparison }): void => {
        if (!comparison) {
          return;
        }
        const newFields =
          comparison.value === PostFilterComparison.not_null
            ? [fieldComparison]
            : [fieldComparison, fieldDate];
        if (fields.length !== newFields.length) {
          setFields(newFields);
        }
      }}
      addAnother={false}
    />
  );
};
